module.exports = "<div class=\"logout_sso\" [innerHTML]=\"logoutMsg\"></div>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/logout/logoutsso.component.html
// module id = 478
// module chunks = 0